<template>
  <el-dialog
    center
    width="600px"
    title="新增广告"
    :visible.sync="dialogFormVisible"
  >
    <el-form :model="addForm" :rules="addRules" ref="addForm">
      <el-form-item
        label="广告标题"
        :label-width="formLabelWidth"
        prop="adName"
      >
        <el-input v-model="addForm.adName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="所属城市"
        :label-width="formLabelWidth"
        prop="areaId"
      >
        <el-cascader
          :options="areaAllList | filterList(areaAllList)"
          placeholder="请选择城市归属省份"
          v-model="addForm.areaId"
          :label-width="formLabelWidth"
          :props="{ checkStrictly: true }"
          clearable
        >
        </el-cascader>
      </el-form-item>

      <el-form-item
        label="广告位置"
        :label-width="formLabelWidth"
        prop="positionId"
      >
        <el-select v-model="addForm.positionId" placeholder="请选择">
          <el-option
            v-for="item in positionData"
            :key="item.positionId"
            :label="item.name"
            :value="item.positionId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="广告图片"
        :label-width="formLabelWidth"
        prop="picture"
      >
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest"
        >
          <img v-if="addForm.picture" :src="addForm.picture" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="图片标签"
        :label-width="formLabelWidth"
        prop="pictureAlt"
      >
        <el-input v-model="addForm.pictureAlt" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="广告链接" :label-width="formLabelWidth" prop="href">
        <el-input v-model="addForm.href" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="开始时间"
        :label-width="formLabelWidth"
        prop="startTime"
      >
        <el-date-picker
          v-model="addForm.startTime"
          type="date"
          autocomplete="off"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="结束时间"
        :label-width="formLabelWidth"
        prop="endTime"
      >
        <el-date-picker
          v-model="addForm.endTime"
          type="date"
          autocomplete="off"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="排序号"
        :label-width="formLabelWidth"
        prop="sortIndex"
      >
        <el-input-number
          v-model="addForm.sortIndex"
          :min="1"
          :max="99999"
          label="最大越排前"
          autocomplete="off"
        ></el-input-number>
      </el-form-item>

      <div class="tooBox">
        <el-form-item
          label="是否开启"
          :label-width="formLabelWidth"
          prop="isOpen"
        >
          <el-switch
            v-model="addForm.isOpen"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        <el-form-item
          label="是否推荐"
          :label-width="formLabelWidth"
          prop="isRecommend"
        >
          <el-switch
            v-model="addForm.isRecommend"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitAdd">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { formData, formRules } from '../form.js';
import { bannerAdd, pictureUpload } from '@/api/bannerApi.js';
import { mapGetters } from 'vuex';
export default {
  name: 'addBanner',
  data() {
    return {
      // 是否显示 对话框
      dialogFormVisible: false,
      addForm: { ...formData },
      addRules: formRules,
      formLabelWidth: '120px',
      imageUrl: '',
      actionUrl: '',
    };
  },
  // inject: ['bannerList'], // 爷组件的方法
  inject: ['reload'],
  computed: {
    ...mapGetters(['areaAllList']),
  },
  props: ['positionData', 'areaData'],
  methods: {
    submitAdd() {
      try {
        this.$refs.addForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          this.addForm.areaId =
            this.addForm.areaId.length > 2
              ? this.addForm.areaId[2]
              : this.addForm.areaId[1];

          await bannerAdd({ ...this.addForm });
          this.$message.success('添加成功!');
          this.dialogFormVisible = false;
          this.addForm = {};
          // 重新获取数据
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file);
      };
    },
    dealImg(options, base64Str, file) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

        //压缩后的图片转base64 url
        /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
         * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        pictureUpload({
          base64String: base64,
          fileName: file.name,
        })
          .then((res) => {
            _this.addForm.picture = res.data.absoluteFileUrl;
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
